<template>
  <v-menu
    :close-on-content-click="false"
    left
    offset-x
    nudge-left="10"
    v-model="show"
    :close-on-click="false"
  >
    <template v-slot:activator="{ on }">
      <v-list-item @click="show = !show" :ripple="false" :class="{ 'v-list-item--active': show }">
        <v-list-item-icon>
          <v-icon>more_vert</v-icon>
        </v-list-item-icon>
      </v-list-item>
    </template>
    <resource-details-card :resource="resource">
      <template v-slow>
        <v-btn
          style="position: absolute; top: 3px; right: 3px;"
          elevation="0"
          fab
          x-small
          @click.native="show = false"
          ><v-icon>close</v-icon></v-btn
        >
      </template>
    </resource-details-card>
  </v-menu>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ResourceDetailsCard from '@/components/Resources/ResourceDetailsCard';

export default {
  props: ['resource', 'value'],
  components: { ResourceDetailsCard },
  data() {
    return {
      userCanEdit: true
    };
  },
  computed: {
    show: {
      get() {
        return this.value == 'details';
      },
      set(v) {
        const val = v ? 'details' : v;
        this.$emit('input', val);
      }
    },
    resourceText: {
      get() {
        return { html: this.resource.text };
      },
      set(v) {
        this.updateResourceText({
          resourceId: this.resource.id,
          text: v
        });
      }
    },
    resourceDescription: {
      get() {
        return { html: this.resource.description };
      },
      set(v) {
        this.updateResourceText({
          resourceId: this.resource.id,
          text: v,
          field: 'description'
        });
      }
    },
    resourceRating: {
      get() {
        return this.resource.rating || 0;
      },
      set(v) {
        this.updateResourceText({
          resourceId: this.resource.id,
          text: v,
          field: 'rating'
        });
      }
    }
  },
  methods: {
    ...mapActions('resources', ['updateResourceText'])
  }
};
</script>

<style></style>
